export const adminSections = [
    {key: 'club-signups', label: 'Заявки в клуб', routeName: 'AdminClubSignups'},
    {key: 'custom-pages', label: 'Страницы', routeName: 'AdminCustomPages'},
    {key: 'orders', label: 'Заказы', routeName: 'AdminOrders'},
    {key: 'promotions', label: 'Промоакции', routeName: 'AdminPromotions'},
    {key: 'users', label: 'Пользователи', routeName: 'AdminUsers'},
    {key: 'roles', label: 'Роли', routeName: 'AdminRoles'},
    {key: 'news', label: 'Новости', routeName: 'AdminNews'},
    {key: 'mailings', label: 'Рассылки', routeName: 'AdminMailings'},
    {key: 'products', label: 'Товары и услуги', routeName: 'AdminProducts'},
    {key: 'price-list', label: 'Прайс-лист', routeName: 'AdminPriceList'},
    {key: 'coins', label: 'Монеты', routeName: 'AdminCoins'},
];

export const superadminSections = [
    {key: 'system', label: 'Состояние системы', routeName: 'AdminSystemStatus'},
    {key: 'system-settings', label: 'Системные настройки', routeName: 'AdminSystemSettings'},
    {key: 'backups', label: 'Резервные копии', routeName: 'AdminBackups'},
];
